import Reflux from 'reflux';

var AppActions = Reflux.createActions([
    'createTopic',
    'getTrendingTopics',
    'getLatestTopics',
    'getAutogeneratedTopics',
    'getAutogeneratedByTitle',
    'getMoreLatestTopics',
    'getRelatedTopics',
    'sugestTranslate',
    'getTopicById',
    'getGlobal',
    'getRandomSentences',
    'cleanSearch',
    'cleanOptions',
    'cleanComments',
    'cleanTopic',
    'newTopicStart',
    'loginUserFacebook',
    'loginUserGoogle',
    'getComments',
    'getMoreComments',
    'getPopularSentencesByTitle',
    'getGlobalComments',
    'newComment',
    'newCommentResponse',
    'voteComment',
    'logout',
    'likeTopic',
    'getTopicActivity',
    'getTopicLists',
    'addToTopicListByName',
    'addToTopicListById',
    'removeTopicFromListByName',
    'removeTopicFromListById',
    'getIsTopicInList',
    'getTopicSuggestions',
    'updateUserProfile',
    'searchOption',
    'cleanOptionsAutocomplete',
    'focusOptionIndex',
    'selectOption',
    'followUser',
    'unfollowUser',
    'getIsSameTopicByMe',
    'getPopularUsers',
    'getFollowedTopics',
    'disableEdition',
    'enableEdition',
    'getUnreadedNotifications',
    'updateUsername',
    'verifyCreatorHash',
    'showSocial'
]);

export default AppActions;



// WEBPACK FOOTER //
// ./src/AppActions.js